import { useRichTextEditor } from '@shared/rich-text-editor-core';

import ControlButton from './control-button';

export interface InsertLatexShortcutControlProps {
  /**
   * Display label rendered inside the toolbar button.
   */
  label: string;
  /**
   * Accessible label / tooltip text.
   */
  ariaLabel: string;
  /**
   * Raw LaTeX source to insert when the button is clicked.
   */
  latex: string;
}

/**
 * A toolbar button that inserts a fixed LaTeX snippet via the `insertLatex`
 * Tiptap command. Used for quick-insert shortcuts (e.g. \beta, \sigma).
 */
function InsertLatexShortcutControl(props: Readonly<InsertLatexShortcutControlProps>) {
  const { label, ariaLabel, latex } = props;
  const { editor } = useRichTextEditor();

  if (!editor) return null;

  return (
    <ControlButton
      aria-label={ariaLabel}
      title={ariaLabel}
      onClick={() => {
        editor.chain().focus().insertLatex(latex).run();
      }}
    >
      <span className='font-serif text-base italic'>{label}</span>
    </ControlButton>
  );
}

export function BetaControl() {
  return (
    <InsertLatexShortcutControl
      label='β'
      ariaLabel='Insert beta (\beta)'
      latex={String.raw`\beta`}
    />
  );
}

export function SdControl() {
  return (
    <InsertLatexShortcutControl
      label='σ'
      ariaLabel='Insert sigma / SD (\sigma)'
      latex={String.raw`\sigma`}
    />
  );
}

export function SummationControl() {
  return (
    <InsertLatexShortcutControl
      label='Σ'
      ariaLabel='Insert summation (\sum)'
      latex={String.raw`\sum`}
    />
  );
}

export default InsertLatexShortcutControl;
